import { STORES_REQUEST, STORES_SUCCESS, STORES_FAILURE,
        STORES_STATUS_REQUEST, STORES_STATUS_SUCCESS, STORES_STATUS_FAILURE,
        STORES_ALL_REQUEST, STORES_ALL_SUCCESS } from '../constants/actionTypes';
import { getApiConfig } from '../utilities';

const getStoresMethods = getApiConfig('Users/GetStores');
const changeStoreStatusMethods = getApiConfig('Users/EnableCustomer');

export const getStores = (page = 0, pageSize = 50, searchKeyword) => {
  return dispatch => {
    dispatch(getStoresRequest());

    const data = {
      page,
      pageSize
    };

    if (searchKeyword) {
      data.FilterBy = {
        filter: searchKeyword
      }
    }

    getStoresMethods.post(data)
      .then(data => { dispatch(getStoresSuccess(data)) })
  }
};

export const getAllStores = (searchKeyword, filterBy, entityType, page = 0) => {
  return dispatch => {
    dispatch(getAllStoresRequest(searchKeyword));

    const data = {
      page: page,
      pageSize: 50,
      FilterBy: {
        'assoc_fab_id': filterBy,
        entityType
      }
    };

    if (searchKeyword) {
      data.FilterBy.filter = searchKeyword;
    }

    getStoresMethods.post(data)
      .then(data => { dispatch(getAllStoresSuccess(data)) })
  }
};

export const changeStoreStatus = (storeId, enabled) => {
  return dispatch => {
    dispatch(changeStoreStatusRequest());

    changeStoreStatusMethods.post({ customerId: storeId, enabled })
      .then(() => { dispatch(changeStoreStatusSuccess()) })
  }
};

export const getStoresRequest = () => {
  return {
    type: STORES_REQUEST
  }
};

export const getStoresSuccess = (data) => {
  return {
    type: STORES_SUCCESS,
    data
  }
};

export const changeStoreStatusRequest = () => {
  return {
    type: STORES_STATUS_REQUEST
  }
};

export const changeStoreStatusSuccess = () => {
  return {
    type: STORES_STATUS_SUCCESS,
    success: true
  }
};

export const getAllStoresRequest = (searchKeyword) => {
  return {
    type: STORES_ALL_REQUEST,
    searchKeyword
  }
};

export const getAllStoresSuccess = (data) => {
  return {
    type: STORES_ALL_SUCCESS,
    data
  }
};

